/* ====================================================================
   VALERE — behaviour for the ported sections
   ====================================================================

   One job: the contents ledger's rows expand to show their note.

   Standalone on purpose. Impact ships a 235 KB theme.js of its own and
   this must not be entangled with it — an Impact update replaces that
   file, and anything of ours living inside it would go with it.

   Delegated from `document`, and bound exactly once. The theme editor
   fires `shopify:section:load` on every save, so a handler attached per
   section accumulates one copy per reload — two handlers flip
   aria-expanded twice on one click, and on an even count the row appears
   dead. Delegation resolves its target from the event, so binding it once
   is both correct and sufficient.

   Everything degrades: with this file absent the rows render as plain
   text with their price, and the note simply stays closed.
   ==================================================================== */
(function () {
  'use strict';

  if (window.__valereSectionsWired) return;
  window.__valereSectionsWired = true;

  document.addEventListener('click', function (event) {
    var row = event.target.closest('.valere-ledger__row[aria-expanded]');
    if (!row) return;
    var open = row.getAttribute('aria-expanded') === 'true';
    row.setAttribute('aria-expanded', String(!open));
  });

  /* Space and Enter already activate a <button>, so there is no keyboard
     handler here. The row is a button precisely so that stays true. */
})();
